import { loginRequest } from "../authConfig";

export const handleLogin = (instance, inProgress) => {
  if (inProgress === "none") {
    if (window.configs.LOGIN_TYPE?.toLowerCase() === "redirect") {
      instance.acquireTokenRedirect(loginRequest);
    } else if (window.configs.LOGIN_TYPE?.toLowerCase() === "popup") {
      instance.acquireTokenPopup(loginRequest);
    } else {
      instance.acquireTokenRedirect(loginRequest);
    }
  }
};

export const handleLogout = (instance, accounts) => {
  instance.logout({
    account: accounts == null ? null : accounts[0],
    postLogoutRedirectUri: `${window.location.protocol}//${window.location.host}/logout.html`,
    authority: window.configs.AUTHORITY,
  });
};

export const handleMenuClick = (setFrameContext, event, name, url, target) => {
  console.groupCollapsed(
    `%cHandle Menu Click: ${name}`,
    "background: #000000; color: #ffffff"
  );
  console.log({ event });
  console.log({ name });
  console.log({ url });
  console.log({ target });
  console.groupEnd("Handle Menu Click");

  if (target === "frame" && url) {
    if (event) {
      event.preventDefault();
    }

    // update the url with the iframe information for easy sharing of urls
    let href = new URL(window.location.href);
    let searchParams = href.searchParams;
    searchParams.set("name", name);
    searchParams.set("url", url);
    href.search = searchParams.toString();
    window.history.pushState({}, name.toString(), href.toString());

    setFrameContext((prevState) => ({
      ...prevState,
      frameName: name,
      frameSrc: url,
    }));
  }
};
